import { render, staticRenderFns } from "./pictureCom.vue?vue&type=template&id=7f9c0b7e&"
import script from "./pictureCom.vue?vue&type=script&lang=js&"
export * from "./pictureCom.vue?vue&type=script&lang=js&"
import style0 from "./pictureCom.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports